import(/* webpackMode: "eager" */ "/home/briar/git/DLOM-2-serverless/frontend/app/ticker-lookup/page.tsx");
